import * as React from 'react';
import FiniteTableService from './FiniteTableService';
import InfiniteTableService from './InfiniteTableService';
export const NewFiniteTableContext = React.createContext(new FiniteTableService());
export const NewInfiniteTableContext = React.createContext(new InfiniteTableService());
export const NewFiniteTableContextProvider = ({ bodyRef, children, flatData, table, tableSettings }) => {
    const value = React.useMemo(() => new FiniteTableService(bodyRef, table, tableSettings, flatData), [bodyRef, flatData, table, tableSettings]);
    return React.createElement(NewFiniteTableContext.Provider, { value: value }, children);
};
export const NewInfiniteTableContextProvider = ({ bodyRef, children, flatData, table, tableSettings, queryKey }) => {
    const value = React.useMemo(() => new InfiniteTableService(bodyRef, table, tableSettings, flatData, queryKey), [bodyRef, flatData, table, tableSettings, queryKey]);
    return React.createElement(NewInfiniteTableContext.Provider, { value: value }, children);
};
